import React from 'react';
import { graphql } from 'gatsby';
import Layout from '../components/layout';
import Videoproject from '../components/videoproject';

export const query = graphql`
    query($slug: String!) {
        contentfulVideoProject(slug: {eq: $slug}) {
            slug
            tags
            title
            category
            shortDescription
            videoSrc
            images {
                id
                fluid (maxWidth: 3000,quality:100) {
                  ...GatsbyContentfulFluid
                }
              }
          }
    }
`

const ProjectTemplate = ({ data }) => {
    const project = data.contentfulVideoProject;

    const tags = project.tags;
    const title = project.title;
    const description = project.shortDescription;
    const url = project.url;
    const category = project.category;
    const imageData = project.images;
    const videoData = project.videoSrc;

    return (
        <Layout>
            <Videoproject
                title={title}
                description={description}
                url={url}
                imageData={imageData}
                tags={tags}
                category={category}
                videoData={videoData}
            />
        </Layout>
    )
}

export default ProjectTemplate;